import styled from 'styled-components';

const HelpWrapper = styled.div`
    position: relative;

    & .show-help {
        opacity: 1;
        pointer-events: auto;
        cursor: pointer;
        top: 0;
    }

    & .hide-help {
        opacity: 0
    }
`;

const CallOutWrapper = styled(HelpWrapper)`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 20px;
    min-height: 195px;
`;

export default CallOutWrapper;

export { HelpWrapper };




// WEBPACK FOOTER //
// ./src/components/atoms/callout/CallOutWrapper.js